const inBrowser = typeof window !== 'undefined';

const $Type = require('../../Type');

const setStyle = function setStyle(object, el) {
  Object.keys(object).map(key => {
    el.style[key] = object[key];
  });
};

const getStyle = function(styleName, el) {

  if (!inBrowser) {
    return '';
  }

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(el, '');
    return el.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return el.style[styleName];
  }

};

const css = function(css, el) {

  if ($Type.isString(css)) {
    return getStyle(css, el);
  } else {
    setStyle(css, el);
  }
}

const showEle = (el) => {
  css({
    'display': 'block'
  }, el);
};

const hideEle = (el) => {
  css({
    'display': 'none'
  }, el);
};


const createEle = (eleName, style) => {

  if (!inBrowser) return;

  let el = document.createElement(eleName);
  if (style) {
    css(style, el);
  }
  
  return el;
}

const createImgFromSrc = (src, style, event) => {

  if (!inBrowser) return;
  
  let img = document.createElement('img');
  img.src = src;

  if (style) {
    css(style, img);
  }


  if (!!event && !!event.click) {
    img.onclick = event.click;
  }

  return img;

}

const m = {
  css,
  showEle,
  hideEle,
  createEle,
  createImgFromSrc
}

module.exports = m;
